import _ from 'lodash';

import {
  getFieldChecked,
  getFieldType,
  getFieldValue,
  getFieldName
} from './utils';

export const isRelatedFieldExisted = (
  field,
  fields,
  orderData,
  isFormTouched
) => {
  const {
    appearsAfterField,
    appearsAfterValue,
    backendFieldValidation
  } = field;

  if (!appearsAfterField && !backendFieldValidation) return true;

  let result = true;
  let i = 0;
  if (appearsAfterField) {
    while (i < appearsAfterField.length && result) {
      const relatedFieldName = getFieldName(appearsAfterField[i]);
      const relatedFieldType = getFieldType(relatedFieldName, fields);
      const relatedFieldValue =
        relatedFieldType === 'Checkbox'
          ? getFieldChecked(relatedFieldName, fields)
          : getFieldValue(relatedFieldName, fields);

      if (relatedFieldName) {
        if (
          fields[relatedFieldName] &&
          fields[relatedFieldName].isVisible &&
          relatedFieldValue
        ) {
          if (appearsAfterValue) {
            let isValueSelected;
            if (_.isArray(relatedFieldValue)) {
              isValueSelected = appearsAfterValue.find(item =>
                relatedFieldValue.includes(item.fields.value)
              );
            } else {
              isValueSelected = appearsAfterValue.find(
                item => relatedFieldValue === item.fields.value
              );
            }
            result = result && typeof isValueSelected !== 'undefined';
          }
        } else if (orderData && orderData[relatedFieldName]) {
          if (fields[relatedFieldName]) {
            if (
              (isFormTouched &&
                orderData[relatedFieldName] === relatedFieldValue) ||
              !isFormTouched
            ) {
              if (appearsAfterValue) {
                const isValueSelected = appearsAfterValue.find(
                  item => orderData[relatedFieldName] === item.fields.value
                );
                result = result && typeof isValueSelected !== 'undefined';
              }
            } else result = false;
          } else if (appearsAfterValue) {
            const isValueSelected = appearsAfterValue.find(
              item => orderData[relatedFieldName] === item.fields.value
            );
            result = result && typeof isValueSelected !== 'undefined';
          }
        } else {
          result = false;
        }
      }
      i += 1;
    }
  }

  if (backendFieldValidation) {
    let isVisible = result;
    for (let index = 0; index < backendFieldValidation.length; index += 1) {
      const {
        fields: { key, value }
      } = backendFieldValidation[index];
      isVisible =
        isVisible &&
        (value.split('|').includes(orderData[key]) ||
          (value.split('|').includes('undefined') &&
            typeof orderData[key] === 'undefined'));
    }
    return isVisible;
  }

  return result;
};

export const getFormData = fields => {
  const result = Object.keys(fields).reduce((acc, key) => {
    const { type, value, checked } = fields[key];
    acc[key] = type === 'Checkbox' ? checked : value || '';
    return acc;
  }, {});
  if (fields.files) {
    result.files = fields.files;
  }

  return result;
};

export const getFormDataCS = (fields, step, tableCybersecurity) => {
  const result = Object.keys(fields).reduce((acc, key) => {
    const { type, value, checked } = fields[key];
    acc[key] = type === 'Checkbox' ? checked : value || '';
    return acc;
  }, {});
  if (fields.files) {
    result.files = fields.files;
  }
  if (step === 1) {
    result.tableCybersecurity = tableCybersecurity;
  }

  return result;
};
